// extracted by mini-css-extract-plugin
export default {"saveButton":"styles_saveButton__RGzds","saveIcon":"styles_saveIcon__mWl0a","spin":"styles_spin__aNk1s"};